module.exports = "/templates/taskentry.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/taskentry.html
// module id = 471
// module chunks = 0